import {
  SettingsFormControl,
  SettingsGroup,
  TextInputField
} from '@sequencehq/core-components'

import { MerchantBankAccountDetails } from '../bankDetails.types'

import { BASE_INPUT_FIELD_STYLES } from 'SettingsV2/settings.constants'
import { useForm } from '@sequencehq/utils'
import { required } from '@sequencehq/utils/validation'

export const useAustralianAccountForm = ({
  bankDetails,
  showValidationErrors
}: {
  bankDetails?: MerchantBankAccountDetails['value']
  showValidationErrors: boolean
}) => {
  return useForm({
    value: {
      legalName: bankDetails?.australianDestination?.legalName ?? '',
      accountNumber: bankDetails?.australianDestination?.accountNumber ?? '',
      bsb: bankDetails?.australianDestination?.bsb ?? '',
      swiftCode: bankDetails?.australianDestination?.swiftCode ?? ''
    },
    showValidationErrors,
    fieldConfiguration: [
      {
        property: 'legalName',
        validation: [required]
      },
      {
        property: 'accountNumber',
        validation: [required]
      },
      {
        property: 'bsb',
        validation: [required]
      },
      {
        property: 'swiftCode',
        validation: [required]
      }
    ]
  })
}

export const AustralianAccountForm = ({
  fields
}: {
  fields: ReturnType<typeof useAustralianAccountForm>['fields']
}) => (
  <SettingsGroup title="Account details">
    <SettingsFormControl label="Legal name" htmlFor="legal-name">
      <TextInputField
        {...BASE_INPUT_FIELD_STYLES}
        placeholder="12345678"
        id="legal-name"
        value={fields.legalName.value}
        validationErrors={fields.legalName.validationErrors}
        onChange={e => {
          fields.legalName.onChange(e.target.value)
        }}
      />
    </SettingsFormControl>
    <SettingsFormControl label="Account number" htmlFor="account-number">
      <TextInputField
        {...BASE_INPUT_FIELD_STYLES}
        placeholder="12345678"
        id="account-number"
        value={fields.accountNumber.value}
        validationErrors={fields.accountNumber.validationErrors}
        onChange={e => {
          fields.accountNumber.onChange(e.target.value)
        }}
      />
    </SettingsFormControl>

    <SettingsFormControl label="BSB" htmlFor="bsb">
      <TextInputField
        {...BASE_INPUT_FIELD_STYLES}
        placeholder="12345678"
        id="bsb"
        value={fields.bsb.value}
        validationErrors={fields.bsb.validationErrors}
        onChange={e => {
          fields.bsb.onChange(e.target.value)
        }}
      />
    </SettingsFormControl>

    <SettingsFormControl label="SWIFT code" htmlFor="swift-code">
      <TextInputField
        {...BASE_INPUT_FIELD_STYLES}
        placeholder="12345678"
        id="swift-code"
        value={fields.swiftCode.value}
        validationErrors={fields.swiftCode.validationErrors}
        onChange={e => {
          fields.swiftCode.onChange(e.target.value)
        }}
      />
    </SettingsFormControl>
  </SettingsGroup>
)
